import React from 'react';

const SessionsTableLoader = () => {
  return (
    <div className="bg-white rounded-lg shadow overflow-hidden animate-pulse">
      {/* Table Header */}
      <div className="min-w-full divide-y divide-gray-200">
        <div className="bg-gray-50">
          <div className="grid grid-cols-6 px-6 py-3">
            {[...Array(6)].map((_, index) => (
              <div key={index} className="h-4 bg-gray-300 rounded w-20"></div>
            ))}
          </div>
        </div>

        {/* Table Body */}
        <div className="bg-white divide-y divide-gray-200">
          {[...Array(5)].map((_, rowIndex) => (
            <div key={rowIndex} className="grid grid-cols-6 px-6 py-4">
              {/* Date & Time */}
              <div className="space-y-2">
                <div className="h-4 bg-gray-200 rounded w-24"></div>
                <div className="h-3 bg-gray-200 rounded w-32"></div>
              </div>

              {/* Patient Name */}
              <div className="h-4 bg-gray-200 rounded w-32"></div>

              {/* Session Type */}
              <div className="h-4 bg-gray-200 rounded w-28"></div>

              {/* Mode */}
              <div className="h-4 bg-gray-200 rounded w-20"></div>

              {/* Status */}
              <div className="h-6 bg-gray-200 rounded w-16"></div>

              {/* Actions */}
              <div className="flex gap-2">
                <div className="h-8 bg-gray-200 rounded w-24"></div>
                <div className="h-8 bg-gray-200 rounded w-20"></div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default SessionsTableLoader; 